import selectraPrimitives from '@/shared/theme/themePrimitives'

export const mandatoryTag = `<span style="color:${selectraPrimitives.errorInput}">*</span> `
